import   React        from "react";

import   Tabs2         from "../../widget/navigation/Tabs2";

import   Cart          from "./Cart";
import   PurchaseHistory  from "./PurchaseHistory";

export interface PurchaseManagmentProps {
  // Créateur ciblé (fiche ouverte depuis la liste "Créateur") — par défaut, le
  // compte connecté (onglet "Achats" historique).
  email?: string;
  // Date de création du compte ciblé — transmise à l'Historique pour remonter
  // jusque-là plutôt que de se limiter à "depuis hier" (cf. PurchaseHistory).
  creationDate?: Date | null;
}

// Onglet "Achats" — panier en cours et historique d'achats du créateur (connecté,
// ou ciblé via `email` depuis sa fiche).
export const PurchaseManagment: React.FC<PurchaseManagmentProps> = ({ email, creationDate }) => {

  return (
    <Tabs2
      tabs={[
        { label: "Panier",     children: <Cart email={email} /> },
        { label: "Historique", children: <PurchaseHistory email={email} creationDate={creationDate} /> },
      ]}
    />
  );
};

export default PurchaseManagment;
